// Blog metadata for listing page
const blogsRegistry = {
  // "breck-school-tour": {
  //   id: "breck-school-tour",
  //   title: "Breck School's Live Drone Tour: From Hawaii to Minneapolis",
  //   date: "April 15, 2025",
  //   author: "Skyhost Team",
  //   authorAvatar: "/blog_assets/logo.png",
  //   image: "/blog_assets/brecks_flight.JPG",
  //   excerpt:
  //     "Discover how 75 Breck School students experienced Hawaii's Koko Crater region through a live drone tour that transformed an ordinary lesson into dynamic exploration.",
  //   tags: ["Education", "Case Study", "Remote Outdoor Classes"],
  // },
  // "climate-change-sea-cortes": {
  //   id: "climate-change-sea-cortes",
  //   title:
  //     "Witnessing Climate Change: A Tour Over the Sea of Cortés with Regi Domingo",
  //   date: "August 20, 2024",
  //   author: "Skyhost Team",
  //   authorAvatar: "/blog_assets/logo.png",
  //   image: "/blog_assets/sea-of-cortes_banner.png",
  //   excerpt:
  //     "Join marine ecologist Regi Domingo on a virtual tour of the Sea of Cortés to witness the impacts of climate change and ongoing conservation efforts.",
  //   tags: ["Climate Change", "Marine Conservation", "Sustainability"],
  // },
  // "real-time-learning": {
  //   id: "real-time-learning",
  //   title: "Why Real-Time Learning Beats Pre-Recorded Videos",
  //   date: "October 3, 2024",
  //   author: "Skyhost Team",
  //   authorAvatar: "/blog_assets/logo.png",
  //   image: "/blog_assets/classroom.png",
  //   excerpt:
  //     "Pre-recorded videos fall flat while live experiences spark curiosity. We explore the science behind why students retain more information when they can interact and ask questions in real-time.",
  //   tags: ["Education", "Real-Time Learning", "Student Engagement"],
  // },
  // "school-differentiation": {
  //   id: "school-differentiation",
  //   title: "Using Live Drone Tours to Differentiate Your School",
  //   date: "July 15, 2024",
  //   author: "Skyhost Team",
  //   image: "/blog_assets/differentiate_banner.jpeg",
  //   excerpt:
  //     "In a competitive education market, schools need unique offerings. Learn how administrators are using live drone experiences to attract prospective families and showcase innovative teaching approaches.",
  //   tags: ["Education", "School Marketing", "Virtual Tours"],
  // },
  // "tuition-free-education": {
  //   id: "tuition-free-education",
  //   title: "Supporting Tuition-Free Education Through Skyhost",
  //   date: "August 25, 2024",
  //   author: "Skyhost Team",
  //   authorAvatar: "/blog_assets/logo.png",
  //   image: "/blog_assets/tuition_free.jpg",
  //   excerpt:
  //     "Learn how Skyhost is expanding access to immersive drone tours for under-resourced schools and students through our tuition-free education initiative.",
  //   tags: ["Education", "Accessibility", "Social Impact"],
  // },
  // "education-curriculum": {
  //   id: "education-curriculum",
  //   title: "Curriculum Alignment: Mapping Drone Tours to Educational Standards",
  //   date: "September 5, 2024",
  //   author: "Dr. Emily Martinez",
  //   authorAvatar: "/blog_assets/shekhar.png",
  //   image: "/blog_assets/curriculum.jpg",
  //   excerpt:
  //     "How to align Remote Outdoor Classes with Curriculum standards for maximum educational impact.",
  //   tags: ["Education", "Curriculum", "Teaching Resources"],
  // },
  // "sustainability-drone-education": {
  //   id: "sustainability-drone-education",
  //   title: "Exploring Sustainability Through Live Drone Flights",
  //   date: "August 15, 2024",
  //   author: "Skyhost Team",
  //   authorAvatar: "/blog_assets/logo.png",
  //   image: "/blog_assets/sdg_banner.png",
  //   excerpt:
  //     "How live drone tours provide students with real-time environmental insights and foster a deeper understanding of sustainability challenges.",
  //   tags: ["Education", "Sustainability", "Environmental Education"],
  // },
  // "enrollment-boost": {
  //   id: "enrollment-boost",
  //   title: "How Schools Can Boost Enrollment with Unique Learning Experiences",
  //   date: "August 10, 2024",
  //   author: "Skyhost Team",
  //   authorAvatar: "/blog_assets/logo.png",
  //   image: "/blog_assets/enrollment_banner.jpg",
  //   excerpt:
  //     "Learn how innovative experiences like drone-powered field trips can help your school stand out and attract more students.",
  //   tags: ["Education", "School Marketing", "Enrollment"],
  // },
  // "remote-field-trips": {
  //   id: "remote-field-trips",
  //   title: "Remote Field Trips: A New Edge in Student Engagement",
  //   date: "August 5, 2024",
  //   author: "Skyhost Team",
  //   authorAvatar: "/blog_assets/logo.png",
  //   image: "/blog_assets/globe.png",
  //   excerpt:
  //     "Traditional field trips face budget cuts and logistical hurdles. We compare costs and outcomes, showing how virtual explorations eliminate travel barriers while maintaining educational impact.",
  //   tags: ["Education", "Remote Outdoor Classes", "Student Engagement"],
  // },
  // "education-drones": {
  //   id: "education-drones",
  //   title: "Transforming Education Through Remote Outdoor Classes",
  //   date: "September 10, 2024",
  //   author: "Michael Torres",
  //   authorAvatar: "/blog_assets/shekhar.png",
  //   image: "/blog_assets/classroom.png",
  //   excerpt:
  //     "How drone technology is making education more immersive and accessible for students everywhere.",
  //   tags: ["Education", "Virtual Tours", "Technology"],
  // },
  // geography: {
  //   id: "geography-drone-lessons",
  //   title: "How Skyhost Brings Geography Lessons to Life",
  //   date: "June 7, 2024",
  //   author: "Skyhost Team",
  //   image: "/blog_assets/map_banner.png",
  //   excerpt:
  //     "Discover how live drone flights transform geography class into an immersive, inquiry-driven adventure.",
  //   tags: ["Geography", "Education", "Drone Tours"],
  //   route: "/blog/geography-drone-lessons",
  // },
  // "team-building-tips": {
  //   id: "team-building-tips",
  //   title: "5 Ways Virtual Team Building Improves Remote Work Culture",
  //   date: "September 15, 2024",
  //   author: "Sarah Johnson",
  //   authorAvatar: "/blog_assets/shekhar.png",
  //   image: "/blog_assets/teams_banner.png",
  //   excerpt:
  //     "Remote teams often struggle with connection and culture. Discover how virtual team outings can transform your remote team's cohesion and productivity.",
  //   tags: ["Team Building", "Remote Work", "Virtual Events"],
  // },
  // "remote-outdoor-classes": {
  //   id: "remote-outdoor-classes",
  //   title: "Remote Outdoor Classes: Blending Drone Technology with Nature",
  //   date: "October 10, 2024",
  //   author: "Skyhost Team",
  //   authorAvatar: "/blog_assets/logo.png",
  //   image: "/blog_assets/classroom.png",
  //   excerpt:
  //     "When students can't go to nature, we bring nature to them. Teachers report higher engagement when outdoor environments are streamed live into classrooms versus showing recorded nature videos.",
  //   tags: ["Education", "Outdoor Learning", "Global Awareness"],
  // },
  // "stem-integration": {
  //   id: "stem-integration",
  //   title: "How Schools Can Integrate Skyhost into STEM Programs",
  //   date: "October 17, 2024",
  //   author: "Skyhost Team",
  //   authorAvatar: "/blog/logo.png",
  //   image: "/blog_assets/stem.jpg",
  //   excerpt:
  //     "STEM education thrives on real-world applications. This practical guide shows how drone data, flight patterns, and aerial observations connect directly to physics, engineering, and math standards.",
  //   tags: ["Education", "STEM", "Curriculum Integration"],
  // },
  // "brand-connection": {
  //   id: "brand-connection",
  //   title: "How Brands Can Use Live Drone Tours to Connect with Customers",
  //   date: "October 24, 2024",
  //   author: "Skyhost Team",
  //   authorAvatar: "/blog/logo.png",
  //   image: "/blog_assets/brand.png",
  //   excerpt:
  //     "Marketing teams at luxury resorts and real estate firms have found unexpected success with live property tours. This article shares conversion metrics and customer feedback from early adopters.",
  //   tags: ["Marketing", "Brand Engagement", "Customer Experience"],
  // },
  "pilot-playbook": {
    id: "pilot-playbook",
    title: "The Pilot Playbook",
    subheading: "Ideal Setup for Live Drone Streaming",
    date: "October 1, 2025",
    author: "Skyhost Team",
    authorAvatar: "/blog_assets/logo_light.png",
    // image: "/blog_assets/playbook.png",
    excerpt:
      "Live drone streaming is an amazing way to let clients virtually join a flight in real time, but it only works well if the pilot's setup is dialed in. Discover how to optimize your live streaming setup for crystal-clear video and smooth collaboration.",
    tags: ["Pilot Guide", "Live Streaming", "DJI", "Setup", "Best Practices"],
  },
  "billable-live-experience": {
    id: "billable-live-experience",
    title: "From Footage to Feeds",
    subheading: "Turn Every Flight into a Billable Live Experience",
    date: "May 15, 2025",
    author: "Skyhost Team",
    authorAvatar: "/blog_assets/logo_light.png",
    // image: "/blog_assets/feature_team.png",
    excerpt:
      "For years, drone operators have flown missions only to disappear into file transfers and edits. But what if the most valuable part—the actual flight—is what clients want to see? Discover how live access transforms workflows and increases revenue by 15–30%.",
    tags: ["Drone Operations", "Business", "Live Streaming", "Revenue"],
  },
  "remote-inspections-trust": {
    id: "remote-inspections-trust",
    title: "Remote Inspections Clients Actually Trust",
    subheading: "Live, Clear, and Truly Actionable",
    date: "July 10, 2025",
    author: "Skyhost Team",
    authorAvatar: "/blog_assets/logo_light.png",
    // image: "/blog_assets/feature_operator.png",
    excerpt:
      "For years, remote inspections have lived in a strange gray zone. Everyone claims they want them—faster, cheaper, safer—but the moment the word 'remote' appears, doubts creep in. Discover how live, collaborative inspections eliminate skepticism and cut site revisits by 25–50%.",
    tags: ["Remote Inspections", "Industrial", "Solar", "Telecom", "Utilities"],
  },
  "gigs-to-mrr-retainers": {
    id: "gigs-to-mrr-retainers",
    title: "From Gigs to MRR",
    subheading: "Productize Your Drone Ops with Live Access Retainers",
    date: "September 15, 2025",
    author: "Skyhost Team",
    authorAvatar: "/blog_assets/logo_light.png",
    // image: "/blog_assets/business.png",
    excerpt:
      "Every drone operator eventually feels the same pressure: the month looks full, then suddenly three clients delay projects and the calendar collapses. Discover how live-access retainers transform feast-or-famine cycles into predictable monthly revenue.",
    tags: ["Business", "Retainers", "MRR", "Drone Operations"],
  },
  "event-aerial-overwatch": {
    id: "event-aerial-overwatch",
    title: "Win Bigger Event Contracts with Real-Time Aerial Overwatch",
    subheading:
      "How live drone feeds transform event coordination and security",
    date: "August 20, 2025",
    author: "Skyhost Team",
    authorAvatar: "/blog_assets/logo_light.png",
    // image: "/blog_assets/deal.png",
    excerpt:
      "Event work is a strange mix of adrenaline, pressure, and constant improvisation. When a drone provides a live overhead feed, the event suddenly becomes legible. Discover how aerial overwatch gives you a seat at the operations table and makes your service indispensable.",
    tags: ["Events", "Aerial Overwatch", "Security", "Event Management"],
  },
};

export { blogsRegistry };
